var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-walkthru-step"},[_c('v-stepper-step',{attrs:{"step":_vm.step,"complete":_vm.complete,"editable":""}},[_vm._t("default")],2),_c('v-stepper-content',{attrs:{"step":_vm.step}},[_vm._t("detail")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }